
import { useOnScrollTransition } from "@/hooks";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "Photo",
  setup() {
    const photo = ref([]);

    useOnScrollTransition(photo, "animate-scroll-right");

    return { photo };
  },
});
